'use strict';


export class TilesPluginCore {
	constructor (type) {
		this.type = type;
	}
	
	update() {}
	
	resize() {}
	
	dispose() {}
	
	disable() {}
	
	enable() {}
}
